<div style="position: relative;">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{sectionclass}}">
        <div *ngIf="hasLiftData; else noLiftDataBlock">
            <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header">
                <div class="o-stack__cell">
                    <h5>{{sectiontitle}}</h5>
                </div>
            </div>
            <div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content stats_content">
                <div class="o-stack o-stack--center _u-px-small lift_stats">
                    <div class="o-stack__cell content_mainCls">
                        <h5>Digital Lift</h5>
                        <span class="u-font-medium u-lh-normal u-opacity-80p stats_value" *ngIf="liftStatsData">{{liftStatsData.digitalLift}}x</span>
                    </div>
                    <div class="o-stack__cell content_mainCls">
                        <h5>Exposed Rate</h5><span class="u-font-medium u-lh-normal u-opacity-80p stats_value" *ngIf="liftStatsData">{{liftStatsData.exposedRate}}%</span>
                    </div>
                    <div class="o-stack__cell content_mainCls">
                        <h5>Baseline Rate</h5><span class="u-font-medium u-lh-normal u-opacity-80p stats_value" *ngIf="liftStatsData">{{liftStatsData.baseLineRate}}%</span>
                    </div>
                </div>
                <div class="content_mainCls lift_stats_subsection">People who saw your digital
                    ads were <b> <span *ngIf="liftStatsData">{{liftStatsData.digitalLift}}</span> times more likely to visit
                        your website </b> than the unexposed audience
                </div>
                <div class="no-data-container" *ngIf="!hasData">
                    <div>
                        <div class="display_lift_no_data_header">
                            <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header">
                                <div class="o-stack__cell">
                                    <h5>{{sectiontitle}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="map-no-data">No Data to Display</div>
                </div>
            </div>
        </div>
        <ng-template #noLiftDataBlock>
            <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header no_lift_data_header">
                <div class="o-stack__cell">
                    <h5>{{sectiontitle}}</h5>
                </div>
            </div>
            <div class="analytics-portlet-content u-px-small no_lift_data_block stats_content">
                <div class="lift_stats_subhead r6_lift_stats_subhead">
                    Campaigns in the selected date range are not eligible for lift reporting.
                </div>
                <div class="lift_stats_sub_section">
                    <div class="lift_stats_subhead" style="padding-top: 5px;">
                        A campaign must meet all of the following 3 requirements to receive lift reporting:
                    </div>
                    <div>
                        <ul class="lift_stats_list">
                            <li> - Campaign must have the pixel placed and firing on the website</li>
                            <li> - Campaign must run for 3 consecutive months</li>
                            <li> - Campaign must run at least 50,000 audience extension impressions per month</li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
